import { render } from "./App.vue?vue&type=template&id=1ed1c8c6&scoped=true&bindings={}"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1ed1c8c6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1ed1c8c6"

export default script